<template>
    <b-card no-body>
        <b-card-header>
            <h5 class="mb-0 text-white"><b>FILTROS</b></h5>
        </b-card-header>
        <b-card-body class="pt-2">
            <b-row>

                <b-col
                    cols="12"
                    md="3"
                    class="mb-2"
                >
                    <label for="states"><strong>ESTADO(S)</strong></label>
                    <v-select
                        id="states"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.statesArray"
                        :options="options.states"
                        class="w-100"
                        @input="inputStatesVal()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="3"
                    class="mb-2"
                >
                    <label for="conditions"><strong>CONDICIÓN(ES)</strong></label>
                    <v-select
                        id="conditions"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        v-model="formData.conditionsArray"
                        :options="options.conditions"
                        class="w-100"
                        @input="inputConditionsVal()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="3"
                    class="mb-2"
                >
                    <label><strong>MES</strong></label>
                    <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        v-model="formData.selectedMonth"
                        :options="monthOptions"
                        :reduce="val => val.value"
                        :clearable="true"
                        placeholder="Mes"
                        class="w-100"
                        @input="onPeriodChange()"
                    />
                </b-col>

                <b-col
                    cols="12"
                    md="3"
                    class="mb-2"
                >
                    <label><strong>AÑO</strong></label>
                    <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        v-model="formData.selectedYear"
                        :options="yearOptions"
                        :reduce="val => val.value"
                        :clearable="true"
                        placeholder="Año"
                        class="w-100"
                        @input="onPeriodChange()"
                    />
                </b-col>

            </b-row>

        </b-card-body>
    </b-card>
</template>

<script>

    import { ref, watch } from '@vue/composition-api';
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect
        },
        props: {
            options: {
                type: Object,
                required: true
            }
        },
        setup(props, { emit }) {

            const now = new Date();
            const currentMonth = now.getMonth() + 1;
            const currentYear = now.getFullYear();

            // MONTH OPTIONS
            const monthOptions = [
                { value: 1, label: 'ENERO' },
                { value: 2, label: 'FEBRERO' },
                { value: 3, label: 'MARZO' },
                { value: 4, label: 'ABRIL' },
                { value: 5, label: 'MAYO' },
                { value: 6, label: 'JUNIO' },
                { value: 7, label: 'JULIO' },
                { value: 8, label: 'AGOSTO' },
                { value: 9, label: 'SEPTIEMBRE' },
                { value: 10, label: 'OCTUBRE' },
                { value: 11, label: 'NOVIEMBRE' },
                { value: 12, label: 'DICIEMBRE' }
            ];

            // YEAR OPTIONS
            const yearOptions = [];
            for (let y = 2024; y <= currentYear + 1; y++) {
                yearOptions.push({ value: y, label: String(y) });
            }

            // REFS
            const formData = ref({
                statesArray: [],
                conditionsArray: [],
                selectedMonth: currentMonth,
                selectedYear: currentYear
            });

            const initialized = ref(false);

            // SET DEFAULTS WHEN OPTIONS ARE LOADED
            watch(() => props.options, (newOptions) => {
                if (newOptions && newOptions.states && newOptions.states.length && !initialized.value) {
                    initialized.value = true;

                    // Default state: EN REVISION
                    const enRevision = newOptions.states.find(s => s.label === 'EN REVISIÓN');
                    if (enRevision) {
                        formData.value.statesArray = [enRevision];
                        inputStatesVal();
                    }

                    // Default condition: PENDIENTE (first in list)
                    if (newOptions.conditions && newOptions.conditions.length) {
                        const pendiente = newOptions.conditions.find(c => c.label === 'PENDIENTE') || newOptions.conditions[0];
                        formData.value.conditionsArray = [pendiente];
                        inputConditionsVal();
                    }
                }
            }, { deep: true });

            const inputStatesVal = () => {
                if (formData.value.statesArray)
                {
                    const array = formData.value.statesArray.map(item => item.value);
                    emit('update:statesFilter', array.join(','));

                    return array;
                }

                return null;
            };

            const inputConditionsVal = () => {
                if (formData.value.conditionsArray)
                {
                    const array = formData.value.conditionsArray.map(item => item.value);
                    emit('update:conditionsFilter', array.join(','));

                    return array;
                }

                return null;
            };

            const onPeriodChange = () => {
                if (formData.value.selectedMonth && formData.value.selectedYear) {
                    const m = formData.value.selectedMonth;
                    const y = formData.value.selectedYear;
                    const lastDay = new Date(y, m, 0).getDate();
                    const startStr = `${y}-${String(m).padStart(2, '0')}-01`;
                    const endStr = `${y}-${String(m).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
                    emit('update:startDateRangePickerFilter', `${startStr} ${endStr}`);
                } else {
                    emit('update:startDateRangePickerFilter', null);
                }
            };

            return {
                // DATA
                formData,
                monthOptions,
                yearOptions,

                // METHODS
                inputStatesVal,
                inputConditionsVal,
                onPeriodChange
            }
        }
    }

</script>

<style lang="scss" scoped>

    .card-header {
        background-color: var(--primary);
        padding: 1rem 1.5rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
